import { Tab, Tabs } from '@mui/material';
import type { CountedTab } from '@/finance/useCountedTabs';

interface CountedTabsProps<V extends string, R> {
  tabs: CountedTab<V, R>[];
  counts: Map<V, number>;
  value: V;
  onChange: (value: V) => void;
  label: (value: V, count: number) => string;
}

/** The tab strip for useCountedTabs: one tab per visible filter, its count in the label. */
export function CountedTabs<V extends string, R>({ tabs, counts, value, onChange, label }: CountedTabsProps<V, R>) {
  return (
    <Tabs value={value} onChange={(_, next: V) => onChange(next)} sx={{ mb: 1 }}>
      {tabs.map(s => (
        <Tab
          key={s.value}
          value={s.value}
          label={label(s.value, counts.get(s.value) ?? 0)}
          sx={{ textTransform: 'none' }}
        />
      ))}
    </Tabs>
  );
}
